var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppImageAsyncMessagingSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.36.231A1 1 0 011.386.077l21.784 9.077c1.641.684 1.641 3.008 0 3.692L1.385 21.923a1 1 0 01-1.366-1.12l1.218-6.086a3 3 0 012.57-2.388l7.742-.968c.183-.023.274-.094.328-.16a.535.535 0 00.11-.33.536.536 0 00-.102-.333c-.052-.067-.142-.14-.323-.168L3.72 9.194a3 3 0 01-2.489-2.338L.022 1.21A1 1 0 01.361.23z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppImageAsyncMessagingSend);
export default __webpack_public_path__ + "static/media/app_image_async_messaging_send.cfb9079c2876196be174a0d6dd988ef3.svg";
export { ForwardRef as ReactComponent };